/**
 * One reservation holding seats on this workshop. Extracted from
 * `WorkshopReservations` unchanged (BON-472) — see the sibling files.
 */
import type { WorkshopReservation } from '../../../../api/workshops';
import { ageLabel, stageBadge } from '../../../bookings/reservationFormat';
import { StatusPill } from '../../primitives';

import { WorkshopReservationExpiryLabel } from './WorkshopReservationExpiryLabel';
import { WorkshopReservationSendFailedNote } from './WorkshopReservationSendFailedNote';

export function WorkshopReservationRow({ reservation }: { reservation: WorkshopReservation }) {
  const badge = stageBadge(reservation.stage);
  return (
    <div
      data-testid="workshop-reservation-row"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        padding: '8px 0',
        borderTop: '1px solid var(--nb-border-2)',
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize: 12.5,
            fontWeight: 600,
            color: 'var(--nb-ink)',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {/* A CSR takes the seats before a name exists — a real state. */}
          {reservation.customerName ?? 'No name yet'}
        </div>
        <div style={{ fontSize: 10.5, color: 'var(--nb-subtle)' }}>
          {reservation.reference}
          {reservation.reservedBy ? ` · ${reservation.reservedBy.name}` : ''}
          {` · held ${ageLabel(reservation.createdAt)}`}
        </div>
        {reservation.linkSendFailed && (
          <WorkshopReservationSendFailedNote stage={reservation.stage} />
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
        <span style={{ fontSize: 11.5, color: 'var(--nb-subtle)', whiteSpace: 'nowrap' }}>
          {reservation.seats} {reservation.seats === 1 ? 'seat' : 'seats'}
        </span>
        <WorkshopReservationExpiryLabel expiresAt={reservation.expiresAt} />
        <StatusPill tone={badge.tone} label={badge.label} />
      </div>
    </div>
  );
}
